// assets/nosto-integration-cart.js
// =============================================================================
// SCOPED NOSTO REFRESH FOR CART DRAWER
// =============================================================================
//
// PURPOSE:
// Refreshes only cart drawer Nosto placements when cart opens, leaving
// background page carousels untouched. This prevents the jarring "flash and
// shuffle" UX issue where all Blaze carousels would re-render on cart open.
//
// API USED:
// Uses Nosto's RequestBuilder API for scoped placement loading:
//   api.createRecommendationRequest().setElements([...]).loadRecommendations()
//
// NOTE: api.loadRecommendations() WITHOUT RequestBuilder reloads ALL placements
// globally - do NOT use it for scoped refreshes.
//
// Ref: https://docs.nosto.com/techdocs/apis/frontend/js-apis/recommendations/loading-recommendations
// =============================================================================

(function () {
  'use strict';

  if (window.__nostoCartRefreshInitialized) return;
  window.__nostoCartRefreshInitialized = true;

  // ---------------------------------------------------------------------------
  // Configuration
  // ---------------------------------------------------------------------------

  var LOG_PREFIX = '[NOSTO CART]';

  // Cart drawer placement IDs (from snippets/cart-drawer.liquid)
  var CART_DRAWER_PLACEMENTS = ['cartdrawer-nosto-1', 'cartdrawer-nosto-2'];

  // Throttle: prevents multiple triggers from causing redundant API calls
  var lastRunAt = 0;
  var THROTTLE_MS = 1200;

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  function log() {
    if (window.NOSTO_DEBUG) {
      console.log.apply(console, [LOG_PREFIX].concat([].slice.call(arguments)));
    }
  }

  function canRun() {
    var now = Date.now();
    if (now - lastRunAt < THROTTLE_MS) return false;
    lastRunAt = now;
    return true;
  }

  // ---------------------------------------------------------------------------
  // Core: Scoped Recommendation Refresh
  // ---------------------------------------------------------------------------

  function refreshCartRecommendations(reason) {
    if (typeof window.nostojs !== 'function') {
      log('nostojs not available, skipping refresh');
      return;
    }

    if (!canRun()) {
      log('throttled, skipping refresh:', reason);
      return;
    }

    window.nostojs(function (api) {
      try {
        log('Refreshing cart placements only. reason =', reason);
        api.createRecommendationRequest()
          .setElements(CART_DRAWER_PLACEMENTS)
          .loadRecommendations();
      } catch (e) {
        console.warn(LOG_PREFIX, 'Error in scoped loadRecommendations:', e);
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Triggers (multiple for defense-in-depth, throttle prevents duplicates)
  // ---------------------------------------------------------------------------

  // Trigger 1: Theme event after product added to cart
  document.addEventListener('drawer:cart:opened', function () {
    refreshCartRecommendations('drawer:cart:opened');
  });

  // Trigger 2: Manual cart icon click (when drawer not already open)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('a[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    if (!trigger) return;

    if (trigger.getAttribute('aria-expanded') === 'true') {
      log('cart icon clicked but drawer already open, skipping');
      return;
    }

    // Delay allows drawer animation to start
    setTimeout(function () {
      refreshCartRecommendations('cart-icon-click');
    }, 150);
  });

  // Trigger 3: Manual dispatch (for programmatic use)
  document.addEventListener('cart:nosto-refresh', function () {
    refreshCartRecommendations('cart:nosto-refresh');
  });

  // Trigger 4: MutationObserver fallback (catches all drawer opens)
  var sidebarCart = document.getElementById('sidebar-cart');
  if (sidebarCart && typeof MutationObserver !== 'undefined') {
    var lastAriaHidden = sidebarCart.getAttribute('aria-hidden');

    try {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName !== 'aria-hidden') continue;

          var current = sidebarCart.getAttribute('aria-hidden');
          if (lastAriaHidden !== current && current === 'false') {
            refreshCartRecommendations('drawer-aria-open');
          }
          lastAriaHidden = current;
        }
      });

      observer.observe(sidebarCart, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    } catch (e) {
      // Silent fail - other triggers will still work
    }
  }
})();